import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { resolve } from '@/infrastructure/container';
import { ud_di } from './di';
import { assertBootSubscribers } from './bootSubscribers';
import { type AppBus, TOKEN_IAppBus } from '@/services/AppBus';
import { AppView } from '@/views/AppView';
import { ErrorBoundaryView } from '@/views/ErrorBoundaryView';
import { TOKEN_AppStore } from '@/views/AppStore';
import { TOKEN_ThemeStore } from '@/views/ThemeStore';
import { TOKEN_ToastStore } from '@/views/ToastStore';
import { type AuthStore, TOKEN_AuthStore } from '@/views/AuthStore';

import './index.css';

ud_di();

// Subscribers before the publisher: ToastStore (TOAST_REQUESTED) and ThemeStore (KEY_DOWN) must be alive
// before AppStore's constructor starts the DOM listeners and publishes (INVARIANTS rule 20).
resolve(TOKEN_ThemeStore);
resolve(TOKEN_ToastStore);
const auth = resolve(TOKEN_AuthStore) as AuthStore;

assertBootSubscribers(resolve(TOKEN_IAppBus) as AppBus);

// Publisher last.
resolve(TOKEN_AppStore);

// Process an OIDC redirect callback if present, else load the stored session. Fire-and-forget; it sets the
// observable status the view renders from.
void auth.init();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundaryView>
      <AppView />
    </ErrorBoundaryView>
  </StrictMode>,
);
